import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { Global } from '@emotion/react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import Layout from './components/layout/Layout';
import { globalStyles } from './styles/globalStyles';
import AppRoutes from './Routes/AppRoutes';

const App = () => {
  return (
    <Router>
      <Global styles={globalStyles} />
      <Layout>
        <AppRoutes />
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="dark"
          toastStyle={{ color: '#fff' }}
        />
      </Layout>
    </Router>
  );
};

export default App;
